<template>
  <div class="recruiter ico-browser font_Montserrat v3_color_black_knight px-3">
    <div style="margin-top: 80px;">
      <b-card no-body class="mt-2 v3_box_teal">
        <b-card-body class="v3_box_teal_body">
          <div class="box-body-wrapper flex-column p-4">
              <b class="v3_color_teal mt-4"> Find Your Perfect Candidates</b><br/>
              <span class="v3_color_teal">Specify the criteria of your open job and immediately see how many candidates are interested in it.</span>
              <p />
            <b-row class="w-100 mt-3">
              <b-col sm="12" md="4" lg="3">
                <div class="text-center">
                    <b class="v3_color_teal">Step 1. Select Job Criteria</b>
                </div>
              </b-col>
              <b-col sm="12" md="8" lg="6">
                <div class="text-center">
                    <b class="v3_color_teal">Step 2. Define Job Criteria</b>
                </div>
              </b-col>
              <b-col sm="12" md="12" lg="3">
                <div class="text-center">
                    <b class="v3_color_teal">Step 3. Evaluate Results</b>
                </div>
              </b-col>
          </b-row>
            <b-row class="w-100">
              <b-col sm="12" md="4" lg="3" class="">
                <recruiter-ico-criteria
                  :loading="!criteriaItems.length"
                  :criteria-items="criteriaItems"
                >
                  <template slot-scope="{ items, getLabel }">
                    <div
                      class="d-flex flex-column justify-content-stretch mt-3"
                    >
                      <template v-for="item in items">
                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          :set="(disabled = !isSpecialtySubspecialtySpecified &&
                          item.type !== JOB_QUESTION_TYPES.SPECIALTY)"
                          tabindex="0"
                          class="d-flex flex-column justify-content-stretch"
                          v-if=" item.type !== JOB_QUESTION_TYPES.GENDER && item.type !== JOB_QUESTION_TYPES.VISA_STATUS && item.type !== JOB_QUESTION_TYPES.ETHNICITY && item.type !== JOB_QUESTION_TYPES.BOARD_CERTIFICATION"
                        >
                          <b-button
                            variant="v3_teal_outline text-break"
                            :class="[
                              'mb-2',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            :disabled_1="disabled"
                            :disabled="getLabel(item) == 'Location' ? LocationDisabled : (getLabel(item) == 'Practice Type' ? practiceTypeFlag : (getLabel(item) == 'Maximum Total Compensation') ? maxCompFlag : (getLabel(item) == 'Specialty/Subspecialty' ? false : true) )"
                            @click="onChangeCriteria(item)"
                          >
                            {{ getLabel(item) }}
                          </b-button>
                        </div>
                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          tabindex="0"
                          class="d-flex flex-column justify-content-stretch"
                          v-else-if=" item.type === JOB_QUESTION_TYPES.GENDER || item.type === JOB_QUESTION_TYPES.VISA_STATUS || item.type === JOB_QUESTION_TYPES.ETHNICITY || item.type === JOB_QUESTION_TYPES.BOARD_CERTIFICATION"
                        >
                        <b-button
                            variant="v3_teal_outline text-break"
                            :class="[
                              'mb-2',
                              'position-relative',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            :disabled="isDisabled"
                            @click="onChangeCriteria(item)"
                          >
                            {{ getLabel(item) }}
                            <i class="mdi mdi-lock" aria-hidden="true" />
                          </b-button>
                          
                        </div>
                        <b-tooltip
                          v-if=" item.type !== JOB_QUESTION_TYPES.GENDER && item.type !== JOB_QUESTION_TYPES.VISA_STATUS && item.type !== JOB_QUESTION_TYPES.ETHNICITY && item.type !== JOB_QUESTION_TYPES.BOARD_CERTIFICATION"
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                            Specialty, Location, Practice Type, and Compensation of your opportunity are required to see the yield of matching candidates.
                        </b-tooltip>
                        <b-tooltip
                          v-else
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                            These additional Job Criteria filters are available after you connect this opportunity.
                        </b-tooltip>
                      </template>
                    </div>
                  </template>
                </recruiter-ico-criteria>
              </b-col>
              <b-col sm="12" md="8" lg="6" class="position-relative">
                <div class="border_1 border_light_teal h-100 w-100 p-3">
                  <template v-if="selectedJobQuestion">
                    <div class="h-100">
                      <recruiter-ico-criteria-detail
                        :job-question="selectedJobQuestion"
                        :loading-detail="loadingDetail"
                        @set-criteria-value="onSetCriteriaValue"
                        :filter-user-count="true"
                      />
                    </div>
                    <!-- <b-form-row v-if="!isShowNextBtn &&  selectedJobQuestion">
                      <b-col cols="5" class="d-flex justify-content-right mt-3"></b-col>
                        <b-col cols="7"  class="d-flex justify-content-left mt-3">
                          <b-button
                          variant="primary"
                          type="submit"
                          class="px-5 btn-disable-btn position-bottom"
                          @click="handleButtonClick()"
                          :disabled="isNextDisabled"
                          >
                          <span>Next</span> <i class="mdi mdi-arrow-right-bold ml-1"></i>
                        </b-button>
                      </b-col>
                    </b-form-row> -->
                  </template>
                 
                  <template v-else>
                    <div class="d-flex align-items-center mt-4 w-100">
                      <div
                        class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                      >
                        <span>
                          1. Select and define required Job Criteria to build your job.
                        </span><p />
                        <span>
                          2. Assess “Number of Matches” to see the number of candidates interested in your opportunity.
                        </span><p />
                        <span>
                          3. Click “Connect Your Opportunity” to inform matching candidates their dream job awaits.
                        </span><p />
                      </div>
                    </div>
                  </template>
                </div>
              </b-col>
              <b-col sm="12" md="12" lg="3" class="mt-md-2 mt-lg-0">
                <div
                  class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 px-2"
                >
                  <b-row>
                    <b-col sm="12" md="6" lg="12">
                      <recruiter-ico-criteria-results
                        :criteria-items="criteriaItems"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="12" class="mt-3 mt-md-0 mt-lg-3">
                      <div
                        class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 px-2"
                      >
                        <recruiter-ico-matching
                          :value="matchingValue"
                          :loading="loadingMatching"
                        />
                        <div class="mt-3 d-flex justify-content-center">
                          <b-button
                            v-if="jobOffer"
                            variant="v3_teal_outline"
                            @click="onAfterPaidContinue"
                          >
                            Continue
                          </b-button>
                          <!-- <b-button
                            v-else
                            variant="v3_teal_outline"
                            @click="showPurchaseModal"
                          >
                            Purchase Connect
                          </b-button> -->
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <!-- <p class="font_size_1125rem font-weight-bold v3_color_teal mt-4">
              Let candidates know their ideal job is waiting for them.
            </p> -->
            <b-button class="mt-4" v-if="user" variant="v3_teal_outline" :disabled="!isEnableOpportunityBtn" @click="confirmCustomePofile()">
              Connect Your Opportunity
            </b-button>
            <b-button class="mt-4" v-else variant="v3_teal_outline" :disabled="!isEnableOpportunityBtn"  @click="showComingSoonModal()" @continue="onContinue">
              Connect Your Opportunity
            </b-button>
          </div>
          <coming-soon-modal
            v-if="comingSoonModalVisible"
            :visible="comingSoonModalVisible"
            :job_opportunity_price="this.job_opportunity_price"
            :job_opportunity_duration="this.job_opportunity_duration"
            @modal-close="comingSoonModalVisible = false"
        />
        </b-card-body>
      </b-card>
    </div>
    <purchase-modal
      v-if="isPurchaseModalVisible"
      v-model="isPurchaseModalVisible"
      @cancel="isPurchaseModalVisible = false"
      @job-offer-paid="onJobOfferPaid"
    />
  </div>
</template>

<script>
import Api from '@/providers/Api';
import RecruiterIcoCriteria from '@/components/recruiter/ico/criteria/RecruiterIcoCriteria';
import RecruiterIcoMatching from '@/components/recruiter/ico/matching/RecruiterIcoMatching';
import RecruiterIcoCriteriaDetail from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaDetail';
import RecruiterIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaResults';
import PurchaseModal from '@/components/recruiter/payment/PurchaseModal';
import { createAdditionalCriteriaItems } from '@/helpers/recruiter/IcoBrowser/criteriaHelper';
import {
  JOB_OTHER_CRITERIA,
  JOB_TERMS,
} from '@/helpers/recruiter/jobOfferHelper';
import { COOKIES, JOB_QUESTION_TYPES } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import ComingSoonModal from '@/components/pre-paywall-pages/recruiter/ComingSoonModal';


export default {
  name: 'IcoBrowser',
  components: {
    RecruiterIcoCriteriaDetail,
    RecruiterIcoMatching,
    RecruiterIcoCriteria,
    RecruiterIcoCriteriaResults,
    PurchaseModal,
    ComingSoonModal,
  },
  data: function () {
    return {
      criteriaItems: [],
      selectedJobQuestion: null,
      loadingDetail: false,
      matchingValue: '-',
      loadingMatching: false,
      isPurchaseModalVisible: false,
      jobOffer: null,
      comingSoonModalVisible: false,
      isDisabled: this.$store.state.user ? false : true,
      isShowNextBtn:false,
      LocationDisabled:true,
      practiceTypeFlag:true,
      maxCompFlag:true,
      isNextDisabled:true,
      job_opportunity_price:0,
      job_opportunity_duration:0,
    };
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
      this.isPurchaseModalVisible = true;
    }
  },
  computed: {
    user: function () {
      return this.$store.state.user ? this.$store.state.user : null;
    },
    isSpecialtySubspecialtySpecified: function () {
      const specialtyCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY && item.type !== JOB_QUESTION_TYPES.GENDER
      );

      return (
        specialtyCriteria &&
        specialtyCriteria.value &&
        specialtyCriteria.value.subspecialtyId
      );
      
    },
    isEnableOpportunityBtn: function () {
      const specialtyCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY
      );

      const locationCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.LOCATION
      );

      const practiceTypeCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SELECT_ANY
      );

      const maxTotalCompansation = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SLIDER
      );

      return (
        (specialtyCriteria &&
        specialtyCriteria.value &&
        specialtyCriteria.value.subspecialtyId) &&
        (locationCriteria &&
        locationCriteria.value &&
        locationCriteria.value.location_zip_code) &&
        (practiceTypeCriteria &&
        practiceTypeCriteria.value) &&
        (maxTotalCompansation &&
        maxTotalCompansation.value)
      );
    },
    JOB_QUESTION_TYPES: function () {
      return JOB_QUESTION_TYPES;
    },
    selectedJobQuestionId: function () {
      return this.selectedJobQuestion ? this.selectedJobQuestion.id : null;
    },
  },
  methods: {
    getData: async function () {
      const additionalCriteria = createAdditionalCriteriaItems();
      //const jobQuestions = await Api.getJobQuestionsForIcoBrowser();
      //const jobQuestions = (this.$store.state.user) ? await Api.getJobQuestionsForJobOffer() : await Api.getJobQuestionsForGuestIcoBrowser();
      const jobQuestions = await Api.getJobQuestionsForGuestIcoBrowser();
      
      this.criteriaItems = [...additionalCriteria, ...jobQuestions,...JOB_OTHER_CRITERIA,...JOB_TERMS];

      if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
        const values = JSON.parse(
          this.$cookies.get(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        );
        values.forEach(({ id, type, value }) => {
          if (!value) return;
          const index = this.criteriaItems.findIndex((i) => {
            return (
              i.id === id ||
              (i.type === JOB_QUESTION_TYPES.SPECIALTY &&
                type === JOB_QUESTION_TYPES.SPECIALTY) ||
              (i.type === JOB_QUESTION_TYPES.LOCATION &&
                type === JOB_QUESTION_TYPES.LOCATION)
            );
          });
          if (index === -1) return;
          this.$set(this.criteriaItems[index], 'value', { ...value });
        });
        this.updateMatching();
      }
      const jobOpportunityPrice = await Api.getSettingByKey('job_opportunity_price');
      this.job_opportunity_price = jobOpportunityPrice.value;

      const jobOpportunityDuration = await Api.getSettingByKey('job_opportunity_duration');
      this.job_opportunity_duration = jobOpportunityDuration.value;
      
    },
    onSetCriteriaValue: function (params) {
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.criteriaItems[index], 'value', { ...params });

      if(params.location_zip_code)
      {
        this.$store.state.location_zip_code = params.location_zip_code;
      }

      this.$nextTick(() => {
        this.updateMatching();
        this.handleButtonClick(params.nextStep);
      });
      this.isNextDisabled = false;
      this.$store.state.isComeFromIco = true;
    },
    onChangeCriteria: async function (jobQuestion) {
      const jqIndex = this.criteriaItems.findIndex(
        (jq) => jq.id === jobQuestion.id
      );
      this.selectedJobQuestion = this.criteriaItems[jqIndex];
    },
    updateMatching: async function () {
      this.loadingMatching = true;
      try {
        this.matchingValue = (this.$store.state.user) ? await Api.findNumberOfMatches(this.criteriaItems,0) : await Api.findNumberOfMatchesOnGuestIcoBrowser(this.criteriaItems);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingMatching = false;
      }
    },
    showPurchaseModal: function () {
      this.isPurchaseModalVisible = true;
    },
    onJobOfferPaid: function (jobOffer) {
      this.isPurchaseModalVisible = false;
      this.jobOffer = jobOffer;
    },
    onAfterPaidContinue: function () {
      this.$router.push(`/recruiter/edit-job-offer/${this.jobOffer.id}`);
    },
    confirmCustomePofile: function () {
      this.$store.state.job_offer = this.criteriaItems;
      this.$store.state.set_job_information = true;
      this.$router.push(`/recruiter/ico`);
    },
    showComingSoonModal: function () {
      localStorage.setItem('job_offer_signup_data', JSON.stringify(this.criteriaItems));
      this.$store.state.job_offer = this.criteriaItems;
      this.$store.state.set_job_information = true;
      this.comingSoonModalVisible = true;
    },
    onContinue: function () {
      this.$router.push('/recruiter/sign-up');
    },
    handleButtonClick(nextStep) {
      if(nextStep === 'LOCATION'){
        this.LocationDisabled = false;
        this.selectedJobQuestion = this.criteriaItems[1];
        this.isShowNextBtn=true;
      }else if(nextStep === 'PRTYPE')
      {
        this.practiceTypeFlag = false;
        this.selectedJobQuestion = this.criteriaItems[2];
        this.isShowNextBtn=true;
      }else 
      {
          this.maxCompFlag = false;
          this.selectedJobQuestion = this.criteriaItems[3];
          this.isShowNextBtn=false;
      }
      // if(this.LocationDisabled == false && this.practiceTypeFlag == false && this.maxCompFlag==true)
      // {
      //   this.maxCompFlag = false;
      //   this.selectedJobQuestion = this.criteriaItems[3];
      //   this.isShowNextBtn=true;
      // }else if(this.LocationDisabled == false && this.practiceTypeFlag == true)
      // {
      //   this.practiceTypeFlag = false;
      //   this.selectedJobQuestion = this.criteriaItems[2];
      // }else if(this.LocationDisabled == true)
      // {
      //   this.LocationDisabled = false;
      //   this.selectedJobQuestion = this.criteriaItems[1];
      // }
      // this.isNextDisabled = true;
    },
  },
};
</script>

<style scoped>
@media only screen and (min-width: 320px) and (max-width:768px){
  .box-body-wrapper{
    padding: 1rem;
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
@import '../../../../sass/variables_mixins.scss';

.recruiter {
  font-family: $phairify_font_montserrat;
  margin-top:25px !important;
}
.position-relative{
  position: relative;
}
.position-relative i{
  position: absolute;
  right: 10px;
}
.btn-disable-btn{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  border-color: #00586f !important;
  opacity: 1;
}
.btn-disable-btn:disabled{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #dee9ec !important;
  border: 1px solid #00586f !important;
  border-color: #00586f !important;
  opacity: 1;
}
.btn-disable-btn i{
  font-size: 15px;
}
.btn.btn-primary.disabled{
  border-color: #00586f !important;
}
btn-next{
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  max-height: 30px;
  font: normal normal 550 16px/24px;
  letter-spacing: 0;
  color: #00586f !important;
  background-color: #b0d27b !important;
  border: 1px solid #00586f !important;
  opacity: 1;
  border-radius: 20px;
}
.btn-next i{
  font-size:15px;
}
.position-relative{
  position: relative;
}
.position-bottom{
  position:absolute;bottom: 10px;
}
</style>
